// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rRBlZ","body":"styles_body__IbFXF"};